import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '@app/services/auth.service';
import { EncryptionService } from '@app/services/encryption.service';
import { ScreenSizeService } from '@app/shared/services/screen-size.service';
import { SCREEN_SIZE } from '@app/shared/types/screen-size.enum';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, delay, Observable } from 'rxjs';

@Component({
    selector: 'login',
    templateUrl: './login.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers:[ScreenSizeService]
})
export class LoginComponent implements OnInit {
    formGroup: UntypedFormGroup;
    loginForm: UntypedFormGroup;
    otpForm: UntypedFormGroup;
    showResult = false
    showPassword = false
    isSubmitting: boolean = false;
    currentDate:any;
    currentOtp:any;
    otpBox:boolean=false;
    headerNavColor: string;
    isMobile: boolean;

    @Input() thirPartyLogin = true
 
    constructor(private formBuilder: UntypedFormBuilder, private auth: AuthService, private router: Router, private toastr: ToastrService, private encryptSer: EncryptionService, private cdr: ChangeDetectorRef, private screenSizeSvc: ScreenSizeService) {
        this.screenSizeSvc.onResize$.pipe(delay(0)).subscribe(sizes => {
            const sizeTabletAbove = sizes.includes(SCREEN_SIZE.XXL) ||  sizes.includes(SCREEN_SIZE.XL) || sizes.includes(SCREEN_SIZE.LG)
            if(sizeTabletAbove){
                this.isMobile = false
            } else {
                this.isMobile = true
            }
            this.cdr.markForCheck()
        });
    }
    @HostListener('window:resize', ['$event'])windowResize(event) {
        this.getScreenWidth(event.target.innerWidth)
    }

    ngOnInit() {
        this.getScreenWidth(window.innerWidth)
        this.formGroup = this.formBuilder.group({
            email: ['', [
                Validators.required
            ]],
            password: ['', [
                Validators.required
            ]]
        });
        this.loginForm = this.formBuilder.group({
            contact_no: ['', [
                Validators.required
            ]]
        });
        this.otpForm = this.formBuilder.group({
            otp: ['', [Validators.required, Validators.maxLength(4), Validators.minLength(4)]]
        });
    }

    getScreenWidth(size:number) {
        this.screenSizeSvc.onResize(size)
    }
 
    login() {
        this.auth.loginUser(this.formGroup.value).subscribe((res:any)=>{
            this.toastr.success('Login Successfully!');
            let User ={
                email: res.email,
                username: res.name,
                position: res.position,
                token: res.token,
                clientName: res.clientName
            }
            sessionStorage.setItem('token', res.token);
            this.auth.setUserData(User);
            this.auth.getMenuData().subscribe((res:any)=>{
                this.auth.setMenuData(res);
                this.router.navigateByUrl('/dashboard');
            },(err:any)=>{
                console.log(err);
            });
        },(err:any)=>{
          console.log(err);
            this.toastr.error(err.message);
        })
        // console.log(this.formGroup);
    }

    sendOtp(){
        this.isSubmitting = true;
        let passD= {
            mobileNo:this.loginForm.get('contact_no')!.value,
            currentDate: new Date()
        }
        let mobNo = this.encryptSer.encryptData(JSON.stringify(passD));
        let newMobNo = this.encryptSer.encryptMobileno(this.loginForm.get('contact_no')!.value);
        this.auth.sendOtp({'data':mobNo},newMobNo).subscribe((res:any)=>{
            let resData = JSON.parse(this.decryptNo(res.data));
            this.currentDate = new Date(resData.currentDate);
            this.currentOtp = resData.otp;
            console.log(resData)
            this.otpBox = true;
            this.loginForm.disable();
            this.cdr.detectChanges()
        },(err:any)=>{
            console.log(err);
            this.isSubmitting = false;
            this.toastr.error('Some issue occurred, Please try again after some Time!');
        })
    }
    loginViaOtp(){
        const currentTime = Date.now();
        if((this.otpForm.get('otp')!.value == this.currentOtp) && ((currentTime - this.currentDate) <= 5 * 60 * 1000))
        {
        let stringItem = {
            contact_no: this.loginForm.controls.contact_no.value,
            current_otp: this.otpForm.controls.otp.value
        };
        // console.log(stringItem)
        let encrypted = {
            'data': this.encryptData(JSON.stringify(stringItem))
        }
        this.auth.otplogin(encrypted).subscribe((res:any)=>{
            let decryptD = JSON.parse(this.decryptNo(res.data));
            
            this.toastr.success('Login Successfully!');
            let User ={
                email: decryptD.email,
                username: decryptD.name,
                position: decryptD.position,
                token: decryptD.token,
                clientName: decryptD.clientName
            }
            sessionStorage.setItem('token', decryptD.token+Math.random().toString(36).substring(2, 6));
            this.auth.setUserData(User);
            this.auth.getMenuData().subscribe((res:any)=>{
                this.auth.setMenuData(res);
                this.router.navigateByUrl('/dashboard');
            },(err:any)=>{
                console.log(err);
            });
        },(err:any)=>{
            console.log(err);
            this.toastr.error('Some issue occurred, Please try again after some Time!');
        })
        }
        else{
        this.toastr.error('OTP expired or not not matched, Please try again!');
        }
    }
    decryptNo(mobNo:any){
        return this.encryptSer.decryptData(mobNo);
    }
    encryptData(data:any){
        return this.encryptSer.encryptData(data);
    }

    onShowPasswordClick () {
        this.showPassword = !this.showPassword
    }
 
    onReset() {
        this.formGroup.reset();
    }
}
